import { Link } from 'react-router-dom'

import { useAuth } from 'auth/AuthContext'
import { ROLE_LABELS } from 'lib/format'
import { t } from 'lib/i18n'

import { SystemMessage } from './SystemMessage'

export const ForbiddenPage = ({ message }: { message?: string }) => {
  const { user, signOut } = useAuth()
  const roleName = user ? (user.isAdmin ? ROLE_LABELS.ADMIN : t('مستخدم', 'User')) : ''

  return (
    <SystemMessage
      icon="lock"
      code="403"
      title={t('لا تملك صلاحية الوصول', 'You do not have access')}
      description={message ?? t('هذه الصفحة تتطلب صلاحية لا تملكها. تواصل مع مدير المشروع إن كنت تحتاج الوصول إليها.', 'This page needs a permission you do not have. Contact the Project Manager if you need access.')}
      actions={
        <Link to="/" className="btn btn--primary">
          {t('العودة إلى المشاريع', 'Back to projects')}
        </Link>
      }
      footer={
        user ? (
          <>
            <span>{t(`مسجّل الدخول باسم ${user.name} · ${roleName}`, `Signed in as ${user.name} · ${roleName}`)}</span>
            <button type="button" className="link-button" onClick={signOut}>
              {t('تبديل الحساب', 'Switch account')}
            </button>
          </>
        ) : null
      }
    />
  )
}
